type IconName = 'grid' | 'plus' | 'chart' | 'scale' | 'calendar' | 'check' | 'bell' | 'menu' | 'user';

const paths: Record<IconName, string> = {
  grid: 'M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z',
  plus: 'M12 5v14 M5 12h14',
  chart: 'M4 19V5m0 14h16M7 15l4-5 3 3 5-7',
  scale: 'M12 3v18m-7-4h14M5 7l-2 5h6L5 7zm14 0-3 5h6l-3-5z',
  calendar: 'M4 5h16v16H4z M8 3v4m8-4v4M4 10h16',
  check: 'm5 12 4 4L19 6',
  bell: 'M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9m-8 12h4',
  menu: 'M4 6h16M4 12h16M4 18h16',
  user: 'M20 21a8 8 0 0 0-16 0m8-10a4 4 0 1 0 0-8 4 4 0 0 0 0 8z'
};

export function Icon({ name }: { name: IconName | string }) {
  const path = paths[name as IconName] || paths.grid;
  return <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={path}/></svg>;
}
